import { render, staticRenderFns } from "./copySalaryDetail.vue?vue&type=template&id=3ab1e164&scoped=true&"
import script from "./copySalaryDetail.vue?vue&type=script&lang=js&"
export * from "./copySalaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1e164",
  null
  
)

export default component.exports